/**
 * @author       jordan.sookikian@zumper.com (Jordan Sookikian)
 * @copyright    Copyright (c) 2021, Zumper
 */

import { payloadReducer } from '@zcode/reducers'
import { combineReducers } from 'redux'
import { handleAction } from 'redux-actions'
import { SET_PROFILE_SHARE } from '../constants/index'

export const profileShareReducer = combineReducers({
  profileShare: handleAction(SET_PROFILE_SHARE, payloadReducer, {}),
})
